import * as React from "react";
import { useIntl } from "@grandvisionhq/state";
import { ProductDetailSpecification } from "./ProductDetailSpecification.js";
import { getConfigurationSpecificationItems } from "../../../utils/modules/PrimaryProductInfo/ProductDetailSpecification/utils/get-configuration-specification-items.js";
import { getCategorySpecificationListItems } from "../../../utils/modules/PrimaryProductInfo/ProductDetailSpecification/utils/get-category-specification-list-items.js";
import { defaultCLFeatureSpecifications, defaultSolutionsFeatureSpecifications } from "../../../utils/modules/PrimaryProductInfo/ProductDetailSpecification/utils/product-feature-defaults.js";
import { useProductData } from "../../../../../../context/context/product-context-hooks.js";
import { isContactLens, isSolutions } from "../../../../../../types/types/typeguards.js";
const ProductDetailSpecificationContainer = ({ className }) => {
  const { getLabel } = useIntl();
  const {
    product,
    activeVariant: { specifications },
    specificationConfiguration: opcoSpecificationConfig
  } = useProductData();
  const { commercialCategories } = product;
  const noOpcoSpecificationConfig = opcoSpecificationConfig.length === 0;
  let specificationConfig = opcoSpecificationConfig;
  if (noOpcoSpecificationConfig && isContactLens(product)) {
    specificationConfig = defaultCLFeatureSpecifications;
  } else if (noOpcoSpecificationConfig && isSolutions(product)) {
    specificationConfig = defaultSolutionsFeatureSpecifications;
  }
  const items = [
    ...getConfigurationSpecificationItems(specificationConfig, specifications, getLabel),
    ...getCategorySpecificationListItems(commercialCategories)
  ];
  if (!items.length) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(ProductDetailSpecification, { className, items });
};
export {
  ProductDetailSpecificationContainer
};
//# sourceMappingURL=ProductDetailSpecificationContainer.js.map
